import { instanceOfErrorListResponse, Service, type ErrorListResponse } from '@genial/services';
import { useBreakpointValue } from '@genial/utils';
import { useState } from 'react';

import { useToastCreator } from '../../../hooks/useToastCreator';
import { getValidatedStatusIcon } from '../../../utils/getValidatedStatusIcon';
import { errorDownloadRedeemSpreadsheetMessage, screenName } from '../utils/constants';

export const useSpreadsheetRequestItem = () => {
  const [isDownloadingSpreadsheet, startIsDownloadingSpreadsheetTransition] = useState(false);
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const { showToast, showToastFromError } = useToastCreator('toast-download-redeem-spreadsheet');

  const statusIcon = getValidatedStatusIcon({});

  const handleDownloadRedeemSpreadsheet = async (basketFileId?: string) => {
    try {
      if (!basketFileId) {
        throw new Error('basketFileId is not exists!');
      }
      startIsDownloadingSpreadsheetTransition(true);

      const response = await Service.Basket.V1.getDownloadFileByBasketFileId({
        screenName,
        basketFileId,
      });

      const signedGetUrl = response.data?.preSignedUrl;

      if (!signedGetUrl) {
        console.error('Erro na url: ', signedGetUrl);
        throw new Error('Url invalida');
      }

      window.open(signedGetUrl, '_blank');
    } catch (error) {
      if (instanceOfErrorListResponse(error as object)) {
        (error as ErrorListResponse).errors?.forEach((errorItem) => showToastFromError(errorItem));
        return;
      }

      showToast(...errorDownloadRedeemSpreadsheetMessage);
    } finally {
      startIsDownloadingSpreadsheetTransition(false);
    }
  };

  return { isDownloadingSpreadsheet, handleDownloadRedeemSpreadsheet, statusIcon, isMobile };
};
